import {
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  SIGNUP_RESET,
} from "../../types/auth"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const signupReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGNUP_REQUEST:
      return {
        loading: true,
        message: "",
        error: "",
        success: false,
      }
    case SIGNUP_SUCCESS:
      return {
        loading: false,
        message: action.payload.message || "Signup successful",
        error: "",
        success: true,
      }
    case SIGNUP_FAILURE:
      return {
        loading: false,
        message: "",
        error: action.payload.error || "Signup failed",
        success: false,
      }
    case SIGNUP_RESET:
      return initialState
    default:
      return state
  }
}

export default signupReducer
